export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: 'd4b8623', dateTime: 1790093105518 };